/* eslint-disable no-unused-vars */
import BaseMiddleware from './BaseMiddleware'
import store from '@/store'

export default class PartnerTypeMiddleware extends BaseMiddleware {
    /**
     * Avalia se deve executar este middleware ou não
     *
     * @param {Route} to de qual rota está vindo
     * @param {Route} _from para qual rota está indo
     *
     * @return {boolean} deve executar este middleware?
     */
    shouldRun(_to, _from) {
        return (
            _to.meta.reseller ||
            _to.meta.whitelabel ||
            _to.meta.billable ||
            _to.meta.partner
        )
    }

    /**
     * Executa ações sobre esta rota
     *
     * @param {Route} _to de qual rota está vindo
     * @param {Route} _from para qual rota está indo
     *
     * @return {boolean} deve retornar false quando este middleware modifica a rota com next
     */
    handle(_to, _from, next) {
        let grantAccess = false

        if (
            !grantAccess &&
            _to.matched.some(record => record.meta.billable) &&
            store.getters['reseller/billable']
        ) {
            grantAccess = true
        }

        if (
            !grantAccess &&
            _to.matched.some(record => record.meta.reseller) &&
            store.getters['reseller/isReseller']
        ) {
            grantAccess = true
        }

        if (
            _to.matched.some(record => record.meta.partner) &&
            store.getters['reseller/isPartner']
        ) {
            grantAccess = true
        }

        if (
            !grantAccess &&
            _to.matched.some(record => record.meta.whitelabel) &&
            store.getters['reseller/isWhitelabel']
        ) {
            grantAccess = true
        }

        if (!grantAccess) {
            next({ name: 'dashboard' })
        }

        return true
    }
}
